import React, { useState,useRef ,useEffect} from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

import "./commTableActions.scss";
import useResumeStore from "../../store/resume.store";
import RTableActionsModal from "../RTableActionsModal/index.jsx";
import { getTimeNow } from "../../helper/daytimeutils.js";

export default function CommTableActions({
     handleEmailCleanups=null, updateAvailable,data,checkBoxData,qhjid
}) {
    const { CandidateCommunication } = useResumeStore();
    const [actionType, setActionType] = useState("");
    const [isActionModalOpen, setIsActionModalOpen] = useState(false);

    const handleCancel = () => {
        setIsActionModalOpen(false);
    };

    const encodeJson = (type) =>{

        let encodedJsonValues ={};
        var updateType=""

        //get company details
        encodedJsonValues._id="Not used"
        encodedJsonValues.qhglobaljid="Not USed"
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type ;
        encodedJsonValues.qhjid= qhjid;

        encodedJsonValues.candidatelist =[]
        var num=0
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected,data[idx].candidatestatus)
            if (checkBoxData[idx].selected && type =="EMAIL_INTEREST" ) {
                if((data[idx].candidatestatus != "AVAILABLE")&& (data[idx].candidatestatus != "AVAILABLE_HCTC")&&(
                    data[idx].candidatestatus != "AVAILABLE_HNP")){
                    encodedJsonValues.candidatelist[num]={};
                    encodedJsonValues.candidatelist[num].qhrid =data[idx].qhid;
                    num++;
                    updateType = "EMAIL_INTEREST" 
                }                
            }
            if (checkBoxData[idx].selected && type =="EMAIL_SLOT_REQ" ) {
                //currently not supported
                encodedJsonValues.candidatelist[num]={};
                encodedJsonValues.candidatelist[num].qhrid =data[idx].qhid;

                num++;
                updateType = "EMAIL_SLOT_REQ" 
            } 
            if (checkBoxData[idx].selected && type =="EMAIL_INTERVIEW_REMINDER" ) {
                if( data[idx].interviewaction == "INTERVIEW_ACTION_SCHEDULED"){
                    encodedJsonValues.candidatelist[num]={};
                    encodedJsonValues.candidatelist[num].qhrid =data[idx].qhid;
                    num++;
                    updateType = "EMAIL_INTERVIEW_REMINDER"
                }
            }
            if (checkBoxData[idx].selected && type =="EMAIL_FEEDBACK_REQ" ) {
                encodedJsonValues.feedbacklist[num]={};
                if(( data[idx].interviewaction == "Interview Feedback Pending")
                    ||(data[idx].interviewstatus == "Feedback Pending")){
                        encodedJsonValues.candidatelist[num]={};
                        encodedJsonValues.candidatelist[num].qhrid =data[idx].qhid;
                        num++;
                        updateType = "EMAIL_FEEDBACK_REQ"
                }
            }            
        }        
        //get the current date
        let newDate = getTimeNow()

        encodedJsonValues.updatetype = updateType
        encodedJsonValues.updatedby = {}
        encodedJsonValues.updatedby.type = "team"
        encodedJsonValues.updatedby.id= userData.qhuid;
        encodedJsonValues.updatedby.name= userData.username;
        encodedJsonValues.updatedby.on    = newDate;
             
        return encodedJsonValues
    }
    const handleEmail = (value) => {
        var jasonValues= encodeJson(value)
        CandidateCommunication({
            jasonValues,qhjid
        });
        if(handleEmailCleanups !==null) handleEmailCleanups();
        setIsActionModalOpen(false);
        console.log("Handle Email Interest");
    }
    const handleEmailInterest = (value) => {
        handleEmail("EMAIL_INTEREST");
        console.log("Handle Email Interest");
    }
    const handleSlotMail = (value) => {
        handleEmail("EMAIL_SLOT_REQ");
        console.log("Handle Slot Mail");        
    }

    const handleInterviewReminder = (value) => {
        handleEmail("EMAIL_INTERVIEW_REMINDER");            
        console.log("Handle Interview Reminder");
    }

    const handlefeedback = (value) => {
        handleEmail("EMAIL_FEEDBACK_REQ");            
        console.log("Handle Feedback Mail");        
  }

  const actions = {
    handleEmailInterest: handleEmailInterest,
    handleInterviewReminder: handleInterviewReminder,
    handleSlotMail: handleSlotMail,
    handlefeedback: handlefeedback,
  };
    return (
        <div className="commtable-actions-wrapper">
            <RTableActionsModal
                isModalOpen={isActionModalOpen}
                handleOk={actions[actionType]}
                handleCancel={handleCancel}
                action={actionType}
                actionMessage={"Send Email?"}
            />
            <div className="rtable-selectable-btn-wrapper"  >
                <Button
                    className="rtable-selectable-btn"
                    disabled={!updateAvailable}
	                onClick={() => {
	                setIsActionModalOpen(true);
	                setActionType("handleEmailInterest");
	            }}
                >
                  Interest Mail
                </Button>
                <Button
                    className="rtable-selectable-btn"
                    disabled={!updateAvailable}
	                onClick={() => {
	                setIsActionModalOpen(true);
	                setActionType("handleSlotMail");
	          }}
                >
                  Slot Mail
                </Button>
                <Button
                    className="rtable-selectable-btn"
                    disabled={!updateAvailable}
	                onClick={() => {
	                setIsActionModalOpen(true);
	                setActionType("handleInterviewReminder");
	             }}
                  >
                  Interview Reminder Mail
                </Button>
                <Button
                    className="rtable-selectable-btn"
                    disabled={!updateAvailable}
                    onClick={() => {
                    setIsActionModalOpen(true);
                    setActionType("handlefeedback");
                 }}
                  >
                  Feedback Request Mail
                </Button>                               
            </div>
        </div>
    )
}